import './index.less';
export function Spin() {
  return (
    <div className="spin-container">
      <div className="spin-loading"></div>
    </div>
  );
}
